import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {timestampToDate} from '../../../../utils/date';
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Typography} from "../../../../designSystem/components/Typography";
import {DataCardLayout} from "../../../../designSystem/components/DataCardLayout";
import {
  APPLICATION_STATUS_COLOR_MAP,
  DEFAULT_STATUS_COLOR
} from "../../model/applicationCardStyle";
import {APPLICATION_STATUS_LABEL_MAP} from "../../model/applicationStatus";

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

export const ApplicationCard = ({
  item,
  categoryItem,
  onClickBrowseButton,
  onClickSurveyButton,
}) => {
  const showSurvey = item.status === 'completed' && !('surveyResponses' in item);

  return (
    <DataCardLayout
      topRowSection={
        <React.Fragment>
          <div
            className={cn(
              'inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold',
              'ring-1 ring-inset',
              categoryItem?.color
                ? `${categoryItem.color} text-white ring-white/20`
                : 'bg-gray-100 text-gray-700 ring-gray-200'
            )}
          >
            {categoryItem?.icon ? (
              <FontAwesomeIcon icon={categoryItem.icon} className="text-sm opacity-90"/>
            ) : null}
            <span className="truncate max-w-[180px]">
            {categoryItem?.label || item.category}
          </span>
          </div>

          <span
            className={cn(
              'inline-flex items-center rounded-full px-3 py-1 text-xs font-bold',
              'ring-1 ring-inset',
              APPLICATION_STATUS_COLOR_MAP[item.status] || DEFAULT_STATUS_COLOR
            )}
          >
            {APPLICATION_STATUS_LABEL_MAP[item.status] || ''}
          </span>
        </React.Fragment>
      }
      mainInfoSection={
        <React.Fragment>
          <Typography variant="title">
            {item.patientName}
          </Typography>

          <div className="flex flex-row gap-2">
            <Typography variant="bodyBold">
              申請人:
            </Typography>
            <Typography variant="body">
              {item.applicantName}
            </Typography>
          </div>

          <div className="flex flex-row gap-2">
            <Typography variant="bodyBold">
              申請時間:
            </Typography>
            <Typography variant="body">
              {new Date(timestampToDate(item.createAt)).toLocaleString()}
            </Typography>
          </div>
        </React.Fragment>
      }
      actionSection={
        <React.Fragment>
          {showSurvey ? (
            <ActionButton
              onClick={onClickSurveyButton}
              label="填寫滿意度調查"
              variant="outline"
              iconName="fa-pencil"
            />
          ) : null}

          <ActionButton
            onClick={onClickBrowseButton}
            label="查看詳情"
            variant="outline"
            iconName="fa-eye"
          />
        </React.Fragment>
      }
    />
  );
};
